import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  postModal: boolean;
};

const initialState: InitialState = {
  postModal: false,
};

const postModalSlice = createSlice({
  name: "postModalSlice",
  initialState,
  reducers: {
    togglePostModal: (state, action: PayloadAction) => {
      state.postModal = !state.postModal;
      return state;
    },
  },
});

export const { togglePostModal } = postModalSlice.actions;
export default postModalSlice;
